"use client"

//import axios from "axios";
import { useEffect } from "react"
import { usePathname } from "next/navigation";
import { useRouter } from "next/navigation";
import { useResponsive } from "./useResponsive";
import { removePhoneMask } from "./util";

// UNIQUE USER
const useSetUTMParameters = (onSuccess?: any) => 
{
    useEffect(() => 
    {
        setTimeout(() => 
        {
            const params      = new URLSearchParams(window.location.search);
            const utmSource   = params.get("utm_source");
            const utmMedium   = params.get("utm_medium");
            const utmCampaign = params.get("utm_campaign");
            const utmTerm     = params.get("utm_term");
            const utmContent  = params.get("utm_content");
            const referrer    = document.referrer || null;

            const data: Record<string, string | null> = {};

            if (utmSource)   data.utm_source = utmSource;
            if (utmMedium)   data.utm_medium = utmMedium;
            if (utmCampaign) data.utm_campaign = utmCampaign;
            if (utmTerm)     data.utm_term = utmTerm;
            if (utmContent)  data.utm_content = utmContent;
            if (referrer)    data.referrer = referrer;

            // Tentar salvar no localStorage
            try 
            {
                Object.entries(data).forEach(([ key, value ]) => 
                {
                    if (value) 
                    {
                        localStorage.setItem(key, value);
                    }
                });
            }
            catch (err) 
            {
                console.warn("[useSetUTMParameters] Falha ao salvar UTM no localStorage:", err);
            }

            let dataStorage: Record<string, string | null> = {
                utm_source   : null,
                utm_medium   : null,
                utm_campaign : null,
                utm_term     : null,
                utm_content  : null,
                referrer     : null,
            };

            // Tentar ler do localStorage
            try 
            {
                dataStorage = {
                    utm_source   : localStorage.getItem("utm_source"),
                    utm_medium   : localStorage.getItem("utm_medium"),
                    utm_campaign : localStorage.getItem("utm_campaign"),
                    utm_term     : localStorage.getItem("utm_term"),
                    utm_content  : localStorage.getItem("utm_content"),
                    referrer     : localStorage.getItem("referrer"),
                };
            }
            catch (err) 
            {
                console.warn("[useSetUTMParameters] Falha ao ler UTM do localStorage:", err);
            }

            if (onSuccess) onSuccess(dataStorage);
        }, 3000);
    }, []);
};

const useCustomPush = () =>
{
    const router = useRouter();
    const currentPathname = usePathname();

    const customPush = (pathname: string) => 
    {
        const isAppMobile = currentPathname.startsWith("/mobile");
        router.push((isAppMobile ? "/mobile" : "") + pathname);
    };

    return customPush;
}

const useLinkWhatsapp = () =>
{
    const { isDesktop } = useResponsive();

    const openLinkWhatsapp = (number:string, text = "Olá, gostaria de tirar algumas duvidas.") => 
    {
        if (isDesktop) 
        {
            window.open(
                `https://web.whatsapp.com/send?phone=${removePhoneMask(number)}&text=${text}`,
                "_blank",
            );
        }
        else 
        {
            window.open(
                `https://wa.me/${removePhoneMask(number)}?text=${text}`,
                "_blank",
            );
        }
    };

    return {
        openLinkWhatsapp
    }
}

export {	
    useSetUTMParameters,
    useCustomPush,
    useLinkWhatsapp,
}
